import React from "react";
import PropTypes from "prop-types";
import ReactPlayer from "react-player";

const Player = (props) => {
  const { videoDuration, fileUrl, initialLessonType, sectionId, lessonId } =
    props;

  const handleDuration = (event) => {
    const newDuration = Math.floor(event.target.duration);

    if (videoDuration == newDuration || newDuration === 0 || isNaN(newDuration))
      return;

    patchDuration(newDuration);
  };

  const patchDuration = async (newDuration) => {
    const response = await fetch(
      `/sections/${sectionId}/lessons/${lessonId}/update_duration`,
      {
        method: "PATCH",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        },
        body: JSON.stringify({
          lesson: {
            video_length: newDuration,
          },
        }),
      },
    );
    if (!response.ok) {
      console.log("ERROR");
    }
  };

  const PlayerComponent = () => {
    if (fileUrl && initialLessonType != "video") return;

    return (
      <div className="mb-5 mt-5 border-2 border-primaryYellow aspect-video">
        <ReactPlayer
          src={fileUrl}
          controls
          style={{ height: "100%", width: "100%" }}
          onDurationChange={handleDuration}
        />
      </div>
    );
  };

  return <PlayerComponent />;
};

Player.propTypes = {
  fileUrl: PropTypes.string,
  initialLessonType: PropTypes.string,
  sectionId: PropTypes.string,
  lessonId: PropTypes.string,
  videoDuration: PropTypes.number,
};

export default Player;
